export default "__VITE_ASSET__BFyRnDPX__"